import {
    VIDFLEET_CAMERA_LOGS_REQUEST,
    VIDFLEET_CAMERA_LOGS_RESULT,
    CLEAR_REDUX,
} from 'Redux/actionTypes';

// initial state
const INIT_STATE = {
    Items: [],
    loading: false,
    hasMore: false,
    error: null,
    errorCode: null,
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {

        case VIDFLEET_CAMERA_LOGS_REQUEST:
            return { ...state, loading: true };

        case VIDFLEET_CAMERA_LOGS_RESULT:
            return {
                ...state,
                loading: false,
                hasMore: !action.payload.error ? action.payload.result ? action.payload.result.hasMore : false : state.hasMore,
                Items: !action.payload.error ? action.payload?.hasMore
                    ? [...state.Items, ...action.payload.result.logs]
                    : action.payload.result.logs : [...state.Items],
                error: action.payload.error,
                errorCode: action.payload.errorCode,
            };

        case CLEAR_REDUX:
            return ["", "CAMERA_LOGS"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state }
        default:
            return state;
    }
};
